import { createApp } from 'vue'

import PhotoSwipe from './PhotoSwipe'

let app

export default {
  /**
   * @param {Array} images [{src: '', w: '', h: '', title: ''}]
   * @param {Object} options {index: 0, history: false, change, defaultOptions: {}}
   */
  preview(...args) {
    if (!app) {
      const div = document.createElement('div')
      document.body.appendChild(div)
      const instance = createApp(PhotoSwipe)
      app = instance.mount(div)
      app.$nextTick(() => {
        app.init(...args)
      })
    } else {
      app.init(...args)
    }
  },
  close() {
    app && app.close()
  },
  install(app) {
    app.config.globalProperties.$preview = this.preview
  },
}
